import graphql__14eded242daa4ef34e21 from "./__generated__/MapClusterizedPointMarker_point.graphql.js";import { useCallback, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { Marker } from "react-leaflet";

import getMapElementStyle from "../../Utils/getMapElementStyle";
import { useMapContext } from "../MapContext";
import MapElementIcon from "../MapElementIcon";
import MapElementTooltip from "../MapElementTooltip";

// A point styled without any image nor icon class renders an empty marker, which the
// cluster icon can't be built from. It would crash the whole map as soon as that point
// is the first marker of a cluster, so we don't render it at all, as it wouldn't be
// visible anyway.
const hasDisplayableImage = ({ iconStyle, backgroundStyle }) => {
  return [iconStyle, backgroundStyle].some(imageStyle => {
    return imageStyle?.image || imageStyle?.iconClass;
  });
};

const MapClusterizedPointMarker = props => {
  const point = useFragment(MapClusterizedPointMarker_point, props.point);
  const { onClick } = props;
  const {
    id: elementId,
    hasInformationWindow,
    latitude,
    longitude,
    mapElementGeometryId,
    style
  } = point;

  const { mapKey } = useMapContext();
  const zoomLevel = useSelector(({ map }) => map[mapKey].viewport.zoom);

  const handleMarkerClicked = useCallback(
    event => {
      onClick(event, {
        id: mapElementGeometryId,
        elementId,
        hasInformationWindow
      });
    },
    [elementId, hasInformationWindow, mapElementGeometryId, onClick]
  );

  const eventHandlers = useMemo(() => {
    return { click: handleMarkerClicked };
  }, [handleMarkerClicked]);

  // React Leaflet moves the marker whenever it receives a new position array, even with
  // the same coordinates, which makes the cluster group remove and add it back and closes
  // an opened spider, e.g. when hovering the vector grid elements displayed behind it.
  const position = useMemo(() => [latitude, longitude], [latitude, longitude]);

  const displayedStyle = useMemo(() => {
    return style && getMapElementStyle(zoomLevel, style);
  }, [style, zoomLevel]);

  const icon = useMemo(() => {
    return displayedStyle && MapElementIcon(displayedStyle);
  }, [displayedStyle]);

  const hasPosition = latitude !== null && longitude !== null;
  if (!hasPosition || !displayedStyle) return null;

  const opacity = displayedStyle.iconStyle?.opacity;
  if (!displayedStyle.iconStyle || opacity === 0) return null;
  if (!hasDisplayableImage(displayedStyle)) return null;

  return (
    <Marker
      icon={icon}
      position={position}
      eventHandlers={eventHandlers}
      opacity={opacity}
      zIndexOffset={displayedStyle.zIndexOffset}
    >
      <MapElementTooltip tooltip={point.tooltip} />
    </Marker>
  );
};

const MapClusterizedPointMarker_point = graphql__14eded242daa4ef34e21;

export default MapClusterizedPointMarker;
